import { isValidElement } from "react";
import { Skeleton } from "../StateViews/StateViews";
import "./Table.css";

const Table = ({ columns = [], data = [], emptyMessage = "Aucune donnée", maxHeight, stickyHeader = true, loading = false, skeletonRows = 6, mobileStacked = true }) => {
  // columns can be strings OR objects {key, label}
  const getLabel = (col) => (typeof col === "object" && col !== null ? col.label : col);
  const getKey = (col) => (typeof col === "object" && col !== null ? col.key : col);

  // Render a cell value safely:
  // - React elements (JSX) are rendered directly (no String() conversion)
  // - primitives are coerced to string
  // - plain objects are JSON-stringified to avoid [object Object]
  const renderCell = (val) => {
    if (val === null || val === undefined) return "";
    if (isValidElement(val)) return val;
    if (typeof val === "object") return JSON.stringify(val);
    return String(val);
  };

  return (
    <div
      className={`table-responsive${stickyHeader ? " table-sticky" : ""}${mobileStacked ? " table--stacked" : ""}`}
      style={maxHeight ? { maxHeight, overflowY: "auto" } : undefined}
    >
      <table className="table">
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{getLabel(col)}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {loading ? (
            // Skeleton de chargement (Design System) — conserve l'en-tête, remplit les lignes.
            Array.from({ length: skeletonRows }).map((_, i) => (
              <tr key={`sk-${i}`} aria-hidden="true">
                {(columns.length ? columns : [0]).map((_, j) => (
                  <td key={j}><Skeleton height={14} width={j === 0 ? "55%" : "85%"} /></td>
                ))}
              </tr>
            ))
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length || 1} className="table-empty">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr key={i}>
                {columns.length > 0
                  ? columns.map((col, j) => {
                      const k = getKey(col);
                      const val = row[k] !== undefined ? row[k] : "";
                      // data-label = en-tête de colonne → affiché en vue « carte » mobile.
                      // Uniquement si le libellé est une chaîne (un en-tête JSX, ex. case
                      // « tout sélectionner », ne doit pas devenir un attribut).
                      const label = getLabel(col);
                      const dataLabel = typeof label === "string" ? label : undefined;
                      return <td key={j} data-label={dataLabel}>{renderCell(val)}</td>;
                    })
                  : Object.values(row).map((cell, j) => (
                      <td key={j}>{renderCell(cell)}</td>
                    ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
